var map = {
	"./default_wallpaper_2.png": "ff1e",
	"./wallpaper_fc.png": "e8c9",
	"./wallpaper_four.png": "cb1f",
	"./wallpaper_one.png": "a89f",
	"./wallpaper_second.png": "0fb0",
	"./wallpaper_third.png": "b253"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3cac";